import { Platform } from '../components/lti-modal';

type LtiUserMaterialFreeExercise = {
  id: string;
  userMaxScore?: number;
  lti: {
    ltiResource: string;
    platform: string;
  };
};

type LtiUserMaterialAssignment = LtiUserMaterialFreeExercise & {
  assignmentId: string;
};

export type LtiUserMaterial = LtiUserMaterialAssignment | LtiUserMaterialFreeExercise;

export type Module = {
  id: string;
  name: string;
  subjectName: string;
};

export type Audience = {
  schoolName?: string;
  groupName?: string;
};

function createIdWithPrefix(ltiMaterial: LtiUserMaterial): string {
  if ('assignmentId' in ltiMaterial) return `a-${ltiMaterial.assignmentId}`;

  return `f-${ltiMaterial.id}`;
}

type BuildBookWidgetsUrlParams = {
  platformName: Platform;
  studioLanguage: string;
  ltipsUrl: string;
  ltiUserMaterial: LtiUserMaterial;
  audience?: Audience;
  module: Module;
  reviewUrl?: string;
};

export function buildBookWidgetsUrl({
  platformName,
  studioLanguage,
  ltipsUrl,
  reviewUrl,
  ltiUserMaterial,
  module,
  audience,
}: BuildBookWidgetsUrlParams) {
  const getLoginUrl = `${ltipsUrl}/${ltiUserMaterial.lti.platform}/login-url`;

  const query = new URLSearchParams({
    target_link_uri: reviewUrl || ltiUserMaterial.lti.ltiResource,
    module_id: module.id,
    module_name: module.name,
    subject_name: module.subjectName,
    platform_name: platformName,
    locale: studioLanguage,
    material_id: ltiUserMaterial.id,
    process_scores: 'true',
    id_with_prefix: createIdWithPrefix(ltiUserMaterial),
  });

  if (!ltiUserMaterial.userMaxScore || reviewUrl) query.set('process_scores', 'false');
  if (audience && audience.schoolName) query.set('school', audience.schoolName);
  if (audience && audience.groupName) query.set('group', audience.groupName);

  return `${getLoginUrl}?${query}`;
}
